// Calculate months until YKS (assuming YKS is in June)
export const getMonthsUntilYKS = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const yksDate = new Date(currentYear, 5, 15); // June 15th as approximate YKS date
  
  // If we're past June, use next year's YKS
  if (now > yksDate) {
    yksDate.setFullYear(currentYear + 1);
  }
  
  const monthsDiff = (yksDate.getFullYear() - now.getFullYear()) * 12 + 
    (yksDate.getMonth() - now.getMonth());
  
  return Math.max(1, monthsDiff);
};

export type PricingPlan = {
  id: 'monthly' | '3months' | 'until-yks';
  name: string;
  months: number;
  pricePerMonth: number;
  totalPrice: number;
  discount: number;
};

export const calculatePricingPlans = (basePrice: number, extendDiscount: number = 0.95): PricingPlan[] => {
  const monthsToYKS = getMonthsUntilYKS();
  
  // For 3 months plan, discount compounds 2 times (months 2 and 3)
  const threeMonthDiscount = Math.pow(extendDiscount, 2);
  const threeMonthPrice = Math.round(basePrice * threeMonthDiscount);
  
  // For YKS plan, discount compounds (monthsToYKS - 1) times
  const yksDiscount = Math.pow(extendDiscount, monthsToYKS - 1);
  const untilYksPrice = Math.round(basePrice * yksDiscount);

  return [
    {
      id: 'monthly',
      name: 'Aylık',
      months: 1,
      pricePerMonth: basePrice,
      totalPrice: basePrice,
      discount: 0
    },
    {
      id: '3months',
      name: '3 Aylık',
      months: 3,
      pricePerMonth: threeMonthPrice,
      totalPrice: threeMonthPrice * 3,
      discount: Math.round((1 - threeMonthDiscount) * 100)
    },
    {
      id: 'until-yks',
      name: "YKS'ye Kadar",
      months: monthsToYKS,
      pricePerMonth: untilYksPrice,
      totalPrice: untilYksPrice * monthsToYKS,
      discount: Math.round((1 - yksDiscount) * 100)
    }
  ];
};